export const ROLE_SUPER_ADMIN = 'super-admin';
export const ROLE_ADMIN = 'admin';
export const ROLE_USER = 'user';

export const UserRoleType = [ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_USER];
